import React from "react";
import RerunCheckup from "../Common/RerunCheckup/RerunCheckup.jsx";

function DetailHeader(props) {
  return (
    <>
      <span>
        <a href={window.location.origin}>{`<- Back to Website List`}</a>
      </span>
      <h1 className="header__url">{props.url}</h1>
      <span style={{ fontSize: "1.75em" }}>Rerun Checkup</span>
      <RerunCheckup url={props.url} />
      <br />
      <br />
    </>
  );
}

export default DetailHeader;
